var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28592 5.97937H8.76192V7.21271C9.11859 6.50337 10.0333 5.86604 11.4073 5.86604C14.0413 5.86604 14.6666 7.27804 14.6666 9.86871V14.6667H11.9999V10.4587C11.9999 8.98337 11.6433 8.15137 10.7353 8.15137C9.47592 8.15137 8.95259 9.04804 8.95259 10.458V14.6667H6.28592V5.97937V5.97937ZM1.71325 14.5534H4.37992V5.86604H1.71325V14.5534V14.5534ZM4.76192 3.03337C4.76202 3.25689 4.71769 3.4782 4.63151 3.68443C4.54533 3.89067 4.41902 4.07772 4.25992 4.23471C3.93752 4.55512 3.50113 4.73448 3.04659 4.73337C2.59285 4.73307 2.15746 4.55417 1.83459 4.23537C1.67606 4.07785 1.55018 3.89059 1.46415 3.68433C1.37812 3.47807 1.33364 3.25686 1.33325 3.03337C1.33325 2.58204 1.51325 2.15004 1.83525 1.83137C2.15784 1.51215 2.59341 1.33317 3.04725 1.33337C3.50192 1.33337 3.93792 1.51271 4.25992 1.83137C4.58125 2.15004 4.76192 2.58204 4.76192 3.03337Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInSocial);
export default __webpack_public_path__ + "static/media/linkedInSocial.88c9ddaa54e8734cc72f371b06d0442e.svg";
export { ForwardRef as ReactComponent };